import React from "react";

export default function AreasWeServe() {
  return (
    <section data-testid="areas-we-serve" className="bg-cream py-14">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <h2 className="font-serif font-medium text-ink mb-5 tracking-tight" style={{ fontSize: "clamp(22px, 2.6vw, 30px)" }}>Areas we serve</h2>
        <p className="text-ink/80 leading-relaxed" style={{ fontSize: 17 }}>
          We build and renovate homes throughout the greater Tampa Bay region and down the Gulf Coast through Sarasota. Commercial work across Florida.
        </p>
      </div>
    </section>
  );
}
